<template>
  <div id="customer_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="customerHeader1" v-if="$route.params.id > 0" >Update Customer</span>
          <span class="page-title" id="customerHeader2"  v-else>Add Customer</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackConsumerList" >
            <i class="fp-back"> </i>  Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content customer-crud">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="needs-validation" novalidate id="CustomerForm">
                <div class="form-row row-cols-lg-4 row-cols-md-3 row-cols-1">
                  <div class="col form-group" v-if="is_dealerpro">
                    <label class="control-label require" for="name">Name:</label>
                    <input type="text" class="form-control" v-model="name" id="name" data-val="NAME" placeholder="Enter Name" name="name" data-info="Please enter name">
                    <span class="field-error">{{ nameerrors }}</span>
                  </div>
                  <div class="col form-group" v-if="!is_dealerpro">
                    <label class="control-label">Type:</label>
                    <v-select name="type" placeholder="Select Type" v-model="type" id="type" label="text" :options="custTypeArr">
                    </v-select>
                  </div>
                  <div class="col form-group" id="email-hide">
                    <label class="require" v-bind:class ="( class_id != null && class_id.code == 'UTS')?'control-label':'control-label'" for="email">Email:</label>
                    <input type="text" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email" data-info="Please enter email"
                           data-val="EMAIL">
                    <span class="field-error">{{ emailerrors }}</span>
                  </div>

                  <div class="col form-group" id="phone-hide">
                    <div class="example-label">
                      <label class="control-label require" for="phone_no">Phone No:</label>
                    </div>
                    <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone_no" id="phone_no" data-val="PHONE" data-info="Please enter phone number"
                           placeholder="999-999-9999" name="phone_no" @keypress="isNumber($event)" ref="phoneInput">
                    <span class="field-error">{{ phonenoerrors }}</span>
                  </div>
                  <div class="col form-group" v-if="hide_for_ev == false">
                    <label class="control-label require" for="location_id">Location:</label>
                    <v-select v-model="location_id" id="location_id" name="location_id" data-info="Please select location" placeholder="Select Location."
                              label="text"
                              :options="locationArr">
                    </v-select>
                    <div class="field-error"></div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="contact-name">Contact Name:</label>
                    <input type="text" class="form-control" v-model="contact_name" id="contact-name" data-val="NAME" placeholder="Enter Contact Name" name="contact_name" data-info="Please enter contact name">
                    <span class="field-error">{{ contact_name_error }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label" for="size_of_fleet">Size of Fleet:</label>
                    <input type="number" class="form-control" v-model="size_of_fleet" id="size_of_fleet" placeholder="Enter Size of Fleet" name="size_of_fleet" @keypress="isAmountCheck($event)">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require">Address Line 1: </label>
                    <input type="text" id="address_line_1" name="address_line_1" placeholder="Enter Address Line 1" class="form-control" v-model="address_line_1"
                           data-info="Please enter address line 1" data-val="ADDRESS_LINE_1">
                    <span class="field-error">{{ addressLine1Error }}</span>
                  </div>
                  <div class="col form-group">
                    <label class="control-label">Address Line 2:</label>
                    <input type="text" id="address_line_2" name="address_line_2" placeholder="Enter Address Line 2" class="form-control" v-model="address_line_2">
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="state" >{{state_province}}:</label>
                    <v-select
                      name="state"
                      v-model="state"
                      id="state" label="text"
                      :options="stateArr"
                      :required="true"
                      :placeholder="`Select ${state_province}`"
                    ></v-select>
                    <div class="field-error">{{ stateErrors }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require " for="city_id" >City:</label>
                    <a href="javascript:void(0)" v-on:click="addNewCity()" class="pull-right color-blue link-text"> <i class="fp-add font-weight-bold" style="font-size:10px;"></i> Add City</a>
                    <v-select v-model="city_id" id="city_id" name="city_id" data-info="Please select city"
                              label="text" :filterable="false" :options="cityArr"
                              @search="onSearchCity"
                              @change="cityUpdate"
                              placeholder="Select City" class="custom-ci-auto-search">
                      <template slot="no-options">
                        Search City...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>

                    </v-select>
                    <div class="field-error">{{city_error_msg}}</div>
                  </div>
                  <template v-if = "canAddCity">
                    <div class="citycreate wo-vendorinv-form" >
                      <city-add-form :id="'addCity'" v-on:populateCityId="popCityName($event)" class="citycreate wo-vendorinv-panel"></city-add-form>
                    </div>
                  </template>
                  <div class="col form-group">
                    <label class="control-label require">{{ zip_postal }}</label>
                    <input type="text" :id="postcode" data-info="Please enter postal code" name="postcode"
                           :placeholder="'Enter ' + zip_postal" class="form-control" v-model="postcode"
                           data-val="POSTCODE" @keypress="checkZipValid($event)">
                    <div class="field-error">{{post_code_error}}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label" for="status">Status:</label>
                    <v-select
                      name="status"
                      v-model="status"
                      id="status" label="text"
                      :options="statusArr"
                      :required="true"
                    ></v-select>
                    <div class="field-error"></div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require">Open Date:</label>
                    <div class="input-group">
                      <date-picker placeholder="MM/DD/YYYY" id="open_date" name="open_date" :config="options" v-model="open_date" data-info="Please select date" ></date-picker>
                      <label for="open_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ opendateerrormsg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="dealer_id">Map Dealer:</label>
                    <v-select v-if="loadAllDealers" v-model="dealer_id" name="dealer_id" label="text"
                              :filterable="false" :options="dealerArr"
                              @search="onSearchDealer" @change="mapDealerChanged($event)" placeholder="Search Dealer"
                              class='custom-ci-auto-search close-remove'>
                      <template slot="no-options">
                        Search Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <v-select v-else v-model="dealer_id" name="dealer_id" label="text" :filterable="false" data-info="Please select dealer"
                              :options="dealerArr" readonly placeholder="Select Dealer"
                              class='custom-ci-auto-search close-remove'>
                      <template slot="no-options">
                        Select Dealer...
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.text }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.text }}
                        </div>
                      </template>
                    </v-select>
                    <div class="field-error">{{ dealer_error_msg }}</div>
                  </div>
                </div>

                <!-- billing section -->
                <div class="mt-3">
                  <h5 class="col section-title pl-0">Billing/Mailing Address </h5>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="company_name">Company Name</label>
                    <input type="text" class="form-control" v-model="billing_company_name"
                           id="company_name" placeholder="Enter Company Name" name="company_name"
                           ref="billing_company_name">
                    <div class="field-error">{{ billing_company_name_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="billing_address_line_one">Address Line 1</label>
                    <input type="text" class="form-control" v-model="billing_address_line_one"
                           id="billing_address_line_one" placeholder="Enter Dealer Group Name"
                           name="billing_address_line_one" ref="billing_address_line_one">
                    <div class="field-error">{{ billing_address_line_one_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label " for="billing_address_line_two">Address Line 2</label>
                    <input type="text" class="form-control" v-model="billing_address_line_two"
                           id="billing_address_line_two" placeholder="Enter Dealer Group Name"
                           name="billing_address_line_two" ref="billing_address_line_two">
                    <div class="field-error">{{ billing_address_line_two_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="billing_city">City</label>
                    <input type="text" class="form-control" v-model="billing_city" id="billing_city"
                           placeholder="Enter City Name" name="billing_city" ref="billing_city">
                    <div class="field-error">{{ billing_city_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="state">{{state_province}}:</label>
                    <v-select
                      name="billing_state"
                      v-model="billing_state"
                      id="billing_state" label="text"
                      :options="stateArr"
                      :required="true"
                      :placeholder="`Select Billing ${state_province}`"
                    ></v-select>
                    <div class="field-error">{{ billing_state_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label require" for="billing_zip">{{ zip_postal }}</label>
                    <input type="text" class="form-control" v-model="billing_zip" id="billing_zip"
                           :placeholder="'Enter ' + zip_postal"  name="billing_zip" ref="billing_zip" @keypress="checkZipValid($event)">
                    <div class="field-error">{{ billing_zip_error_msg }}</div>
                  </div>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label" for="name">Contact Name:</label>
                    <input type="text" class="form-control" v-model="billing_contact_name" id="billing_contact_name" data-val="NAME"
                           placeholder="Enter Name" name="billing_contact_name" data-info="Please enter name">
                    <span class="field-error">{{ billing_contact_name_error_msg }}</span>
                  </div>
                  <div class="col form-group" id="billing-email-hide">
                    <label class=" control-label"
                           for="billing_email">Email:</label>
                    <input type="text" class="form-control" v-model="billing_email" id="billing_email" placeholder="Enter Email"
                           name="billing_email" data-info="Please enter email"
                           data-val="EMAIL">
                    <span class="field-error">{{ billing_email_error_msg }}</span>
                  </div>

                  <div class="col form-group" id="billing-phone-hide">
                    <div class="example-label">
                      <label class="control-label" for="billing_phone">Phone No:</label>
                    </div>
                    <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}"
                           v-model="billing_phone" id="billing_phone" data-val="PHONE" data-info="Please enter phone number"
                           placeholder="999-999-9999" name="billing_phone" @keypress="isNumber($event)" ref="billingPhoneInput">
                    <span class="field-error">{{ billing_phone_error_msg }}</span>
                  </div>
                </div>

                <!-- Shipping section -->
                <div class="mt-3">
                  <h5 class="col section-title pl-0">Shipping Address </h5>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label"> </label>
                    <div class="custom-checkbox">
                      <label for="same_as_billing" class="checkbox-custom"> Same as Billing/Mailing Address
                        <input type="checkbox" v-model="shipping_same_as_billing" id="same_as_billing" name="same_as_billing"
                               v-on:click="checkSelected">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label :class="{'control-label': true, require: !shipping_same_as_billing}" for="shipping_company_name">Company Name</label>
                    <input type="text" class="form-control" v-model="shipping_company_name"
                           id="company_name" placeholder="Enter Company Name" name="company_name"
                           ref="shipping_company_name" :disabled="shipping_same_as_billing">
                    <div class="field-error">{{ shipping_company_name_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label :class="{'control-label': true, require: !shipping_same_as_billing}" for="shipping_address_line_one">Address Line 1</label>
                    <input type="text" class="form-control" v-model="shipping_address_line_one"
                           id="shipping_address_line_one" placeholder="Enter Dealer Group Name"
                           name="shipping_address_line_one" ref="shipping_address_line_one"
                           :disabled="shipping_same_as_billing">
                    <div class="field-error">{{ shipping_address_line_one_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label class="control-label " for="shipping_address_line_two">Address Line 2</label>
                    <input type="text" class="form-control" v-model="shipping_address_line_two"
                           id="shipping_address_line_two" placeholder="Enter Dealer Group Name"
                           name="shipping_address_line_two" ref="shipping_address_line_two"
                           :disabled="shipping_same_as_billing">
                    <div class="field-error">{{ shipping_address_line_two_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label :class="{'control-label': true, require: !shipping_same_as_billing}"  for="shipping_city">City</label>
                    <input type="text" class="form-control" v-model="shipping_city" id="shipping_city"
                           placeholder="Enter City Name" name="shipping_city" ref="shipping_city"
                           :disabled="shipping_same_as_billing">
                    <div class="field-error">{{ shipping_city_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label :class="{'control-label': true, require: !shipping_same_as_billing}" for="state">{{state_province}}:</label>
                    <v-select
                      name="shipping_state"
                      v-model="shipping_state"
                      id="shipping_state" label="text"
                      :options="stateArr"
                      :required="true"
                      :disabled="shipping_same_as_billing"
                      :placeholder="`Select Shipping ${state_province}`"
                    ></v-select>
                    <div class="field-error">{{ shipping_state_error_msg }}</div>
                  </div>
                  <div class="col form-group">
                    <label :class="{'control-label': true, require: !shipping_same_as_billing}" for="shipping_zip">{{ zip_postal }}</label>
                    <input type="text" class="form-control" v-model="shipping_zip" id="shipping_zip"
                           :placeholder="'Enter ' + zip_postal" name="shipping_zip" ref="shipping_zip"
                           :disabled="shipping_same_as_billing" @keypress="checkZipValid($event)">
                    <div class="field-error">{{ shipping_zip_error_msg }}</div>
                  </div>
                </div>
                <div class="form-row row-cols-md-4 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label" for="name">Contact Name:</label>
                    <input type="text" class="form-control" v-model="shipping_contact_name" id="shipping_contact_name" data-val="NAME"
                           placeholder="Enter Name" name="shipping_contact_name" data-info="Please enter name"
                           :disabled="shipping_same_as_billing">
                    <span class="field-error">{{ shipping_contact_name_error_msg }}</span>
                  </div>
                  <div class="col form-group" id="email-hide">
                    <label class="control-label"
                           for="shipping_email">Email:</label>
                    <input type="text" class="form-control" v-model="shipping_email" id="shipping_email" placeholder="Enter Email"
                           name="shipping_email" data-info="Please enter email"
                           data-val="EMAIL"
                           :disabled="shipping_same_as_billing">
                    <span class="field-error">{{ shipping_email_error_msg }}</span>
                  </div>

                  <div class="col form-group" id="phone-hide">
                    <div class="example-label">
                      <label class="control-label" for="shipping_phone">Phone No:</label>
                    </div>
                    <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}"
                           v-model="shipping_phone" id="shipping_phone" data-val="PHONE" data-info="Please enter phone number"
                           placeholder="999-999-9999" name="shipping_phone" @keypress="isNumber($event)" ref="shippingPhoneInput"
                           :disabled="shipping_same_as_billing">
                    <span class="field-error">{{ shipping_phone_error_msg }}</span>
                  </div>
                </div>
                <!-- Customer Contact Changes -->
                <hr class="light-hr"/>
                <div class="alert alert-warning hide col-sm-6" id="alertError">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <strong id="errorMsg" class="field-error"></strong>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="CreateConsumerBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateConsumer" >
                    <i class="fp-reload"> </i>  Update
                  </button>
                  <button type="submit" id="CreateConsumerBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateConsumer" >
                    <i class="fp-save"> </i>  Save
                  </button>
                  <button  type="submit" id="createAndContinueCustomerBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateConsumer(flag='Save and Continue')" >
                    <i class="fp-save-continue"> </i>  Save and Continue
                  </button>
                  <button type="submit" id="cancelCustomerBtn" class="btn btn-tertiary" v-on:click.prevent="BackConsumerList" >
                    <i class="fp-close"> </i>  Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";


import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment';

import CityCreate from '@/components/CityCreate.vue';
Vue.component("city-add-form", CityCreate);

export default {
  name: "ConsumerCreate",
  metaInfo() {
    return {
      title: (this.$route.params.id > 0)? "Update Customer | " +process.env.COPYRIGHT_NAME : "Create Customer | " +process.env.COPYRIGHT_NAME
    }
  },

  mixins:[commonMixins,contractMixins],
  data: () => ({
    contactTableKey:1,
    canAddCity:false,
    city_error_msg:"",
    location_id:null,
    selectDateFormat: {value: "m/d/Y", text: '12/23/2019'},
    selectTimeFormat: {value: "h:i:s a", text: '09:58:00 am'},
    dateformat_error_msg: "",
    timeformat_error_msg: "",
    permissions: [],
    cantAccessPage: "",
    name: "",
    username: "",
    usernameerrors: "",
    password: "",
    passworderrors: "",
    confirmpassword: "",
    confirmpassword_error_msg: "",
    email: "",
    emailerrors: "",
    fax_no: "",
    faxerrors: "",
    phone_no: "",
    phonenoerrors: "",
    code: "",
    class_id: null,
    customerClassArr: [],
    classerrors: "",
    loading:false,
    nameerrors: "",
    codeerrors: "",
    size_of_fleet: "",
    size_of_fleet_error_msg: "",
    state: null,
    stateArr: [],
    city_id: null,
    cityArr: [],
    status: {value: "active", text: "Active"},
    statusArr: [
      {
        value: "unverified",
        text: "Unverified"
      },
      {
        value: "active",
        text: "Active"
      },
      {
        value: "inactive",
        text: "Inactive"
      },
    ],
    stage: {value: "potential", text: "Pending Approval"},
    type: null,
    custTypeArr:[
      {
        value: "Corporation",
        text: "Corporation"
      },
      {
        value: "LLC",
        text: "LLC"
      },
      {
        value: "LP",
        text: "LP"
      },
      {
        value: "General Partnership",
        text: "General Partnership"
      },
      {
        value: "Municipality/ Government",
        text: "Municipality/ Government"
      },
      {
        value: "Internal Account",
        text: "Internal Account"
      }
    ],
    stageArr: [
      {
        value: "potential",
        text: "Pending Approval"
      },
      {
        value: "account pending",
        text: "Account Pending"
      },
      {
        value: "credit denied",
        text: "Credit Denied"
      },
      {
        value: "new",
        text: "New"
      },
      {
        value: "existing",
        text: "Existing"
      }
    ],
    stageerrors: "",
    statuserrors: "",
    customer_since: "",
    open_date: "",
    options: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
      widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
      },
    },
    credit_limit_error_msg: "",
    is_national_lease:0,
    deposit_check:0,
    //customer_login_check:0,
    //allow_customer_login:true,
    customer_password:null,
    customer_password_error_message:"",
    wo_credit_warning_at: "",
    wo_credit_warning_at_error_msg: "",
    credit_manager_id: null,
    creditManagerArr: [],
    creditManagererrors: "",
    po_required: 0,
    outstanding_ar: "0",
    outstanding_ar_errors: "",
    term_id: null,
    fuel_term_id:null,
    termArr: [],
    termerrors: "",
    taxerrors: "",
    sales_representative_id: null,
    userArr: [],
    taxstateerrors: "",
    salesrepresentativeerrormsg: "",
    opendateerrormsg: "",
    isEdit: false,

    address_line_1: "",
    address_line_2: "",
    postcode: "",
    timezone_error:"",
    timezones:[],
    codeField1:"",
    codeField2:"",
    codeField3:"",
    disableCustomerSince:false,
    corcentric_code:null,
    customerContactArr:[],
    locationArr: [],
    isEditScreen:false,
    canUpdateFuelTerm:false,
    customerRepresentativeArr:[],
    customer_id:null,
    primeCustomerArr:[],
    primeDisable:false,
    parent_code:null,
    flag:"",
    stageDisable:false,
    enable_corcentric:0,
    corcentric_default_po:null,
    corcentric_inv_date:null,
    is_dealerpro:false,
    env_name:process.env.NODE_ENV,
    hide_for_ev:false,
    termDisable:false,
    consumer_id: null,
    emailRequired:false,
    phoneNoRequired:false,
    faxRequired:false,
    dealer_id: "",
    dealerArr: [],
    dealer_error_msg: "",
    redirectedDealerId: "",
    formFieldsToWatch: [
      'name',
      'email',
      'postcode',
      'contact_name',
      'phone_no',
      'address_line_1',
      'state',
      'city_id',
      'open_date',
      'dealer_id',
      'customerContactArr',
      'billing_company_name',
      'billing_address_line_one',
      'billing_city',
      'billing_state',
      'billing_zip',
      'billing_email',
      'billing_phone',
      'shipping_company_name',
      'shipping_address_line_one',
      'shipping_city',
      'shipping_state',
      'shipping_zip',
      'shipping_email',
      'shipping_phone'
    ],
    fieldError: false,
    addressLine1Error: "",
    stateErrors: "",
    customFlag: '',
    loadAllDealers: false,
    contact_name: '',
    contact_name_error: '',
    billing_company_name: "",
    billing_address_line_one: "",
    billing_address_line_two: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_contact_name: "",
    billing_email: "",
    billing_phone: "",
    shipping_company_name: "",
    shipping_address_line_one: "",
    shipping_address_line_two: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_contact_name: "",
    shipping_email: "",
    shipping_phone: "",
    billing_company_name_error_msg: "",
    billing_address_line_one_error_msg: "",
    billing_address_line_two_error_msg: "",
    billing_city_error_msg: "",
    billing_state_error_msg: "",
    billing_zip_error_msg: "",
    billing_contact_name_error_msg: "",
    billing_email_error_msg: "",
    billing_phone_error_msg: "",
    shipping_company_name_error_msg: "",
    shipping_address_line_one_error_msg: "",
    shipping_address_line_two_error_msg: "",
    shipping_city_error_msg: "",
    shipping_state_error_msg: "",
    shipping_zip_error_msg: "",
    shipping_contact_name_error_msg: "",
    shipping_email_error_msg: "",
    shipping_phone_error_msg: "",
    shipping_same_as_billing: false,
    billingFieldsToWatch: [
      "billing_company_name",
      "billing_address_line_one",
      "billing_address_line_two",
      "billing_city",
      "billing_state",
      "billing_zip",
      "billing_contact_name",
      "billing_email",
      "billing_phone",
    ],
    post_code_error: "",
  }),

  watch:{

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'ev_add_customer') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'ev_load_all_dealer_dropdown') {
            self.loadAllDealers = true;
          }
        }
        if (!self.loadAllDealers) {
          let userObj = JSON.parse(localStorage.getItem("user_obj"));
          self.loadUserDealerMapper(userObj.id);
        }
      }

    },
    //set default 7 for fuel terms
    termArr: function (terms) {
      var self = this;
      if (terms.length > 0) {
        for (var i = 0; i < terms.length; i++) {
          if ((self.env_name == 'velev' || self.env_name == 'velev_test') && terms[i].term == '30' && terms[i].period == 'days' ) {
            self.term_id = {value:terms[i].value,text:terms[i].text};
            self.termDisable = true;
          } else if (terms[i].term == '7' && terms[i].period == 'days' && self.isEditScreen == false ) {
            this.fuel_term_id = {value:terms[i].value,text:terms[i].text}
          }
        }
      }
    },
    //if state value update after then change the city value also update that in thie module.
    state: function(state) {

      var self = this;

      if(self.state == null){
        self.city_id = null;
        self.cityArr = [];
      }
    },
    dealerArr: function(dealerArr){
      if(this.redirectedDealerId != ""){
        for (const dealer of this.dealerArr) {
          if(dealer.value == this.redirectedDealerId){
            this.dealer_id = dealer;
            break;
          }
        }
      }
    }
  },
  created: function() {
    var self = this;

    self.formFieldsToWatch.forEach(field => {
      self.$watch(field, {
        handler: (newValue, oldValue) => {
          self.fieldError = false;
          if((field == 'state' || field == 'city_id') && self.customFlag == 'Save and Continue'){
            oldValue = null;
          }
          if(field == 'name' && (oldValue == undefined && newValue != '')){
            self.ValidateFormFields(field);
          }else if((field == 'phone_no' || field == 'billing_phone' || field == 'shipping_phone') && (newValue != undefined && newValue.length > 12)){
            // do nothing
          }else if((field == 'state' || field == 'city_id') && ((newValue != null && newValue != '') || (oldValue != null && oldValue != ''))){
            self.ValidateFormFields(field);
          }else if((field == 'open_date' || field == 'dealer_id') && newValue != "" && (oldValue != undefined || newValue != null) ){
            self.ValidateFormFields(field);
          }else if((oldValue != undefined && newValue != undefined) && (oldValue != newValue) && newValue != '') {
            self.ValidateFormFields(field);
          }
        },
        immediate: true,
      });
    });
    self.customFlag = "";

    self.billingFieldsToWatch.forEach(field =>{
      self.$watch(field,{
        handler: (newValue) => {
          if(self.shipping_same_as_billing){
            if(field === "billing_company_name"){
              self.shipping_company_name = newValue;
            }
            if(field === "billing_address_line_one"){
              self.shipping_address_line_one = newValue;
            }
            if(field === "billing_address_line_two"){
              self.shipping_address_line_two = newValue;
            }
            if(field === "billing_city"){
              self.shipping_city = newValue;
            }
            if(field === "billing_state"){
              self.shipping_state = newValue;
            }
            if(field === "billing_zip"){
              self.shipping_zip = newValue;
            }
            if(field === "billing_contact_name"){
              self.shipping_contact_name = newValue;
            }
            if(field === "billing_email"){
              self.shipping_email = newValue;
            }
            if(field === "billing_phone"){
              if (newValue.length > 12) {
                self.shipping_phone = newValue.substring(0, 12);
              } else {
                self.shipping_phone = newValue;
              }
            }
          }
        }
      })
    });
  },

  mounted: function() {
    var self = this;
    self.getPermissions();

    if(self.env_name == 'velev' || self.env_name == 'velev_test'){
      self.is_dealerpro = true;
      self.hide_for_ev = true;
    }
    var path = window.location.pathname;
    var segments = path.split("/");

    // Set customer name...if someone tries to create new customer from Add Work Order Page...
    if(self.$route.params.newCustomer != ''){
      self.name = self.$route.params.newCustomer;
    }
    self.redirectedDealerId = self.$route.query
      && self.$route.query.dealerId
      ? self.$route.query.dealerId : '';
    const fields = ['location', 'term', 'customerClass', 'creditManager', 'customer_representative', 'state_codes'];
    if (self.redirectedDealerId) {
      fields.push('single_customer');
    }
    self.loadFieldData(fields, '', self.redirectedDealerId);

    if (segments[3]) {

      self.isEditScreen = true;
      self.primeDisable = true;
      self.loadConsumer();

      $('#email-hide').hide();
      $('#phone-hide').hide();

    }

    if (!segments[3]) {
      //set default date today
      var todayDate = self.getTodayDate();
      self.customer_since = moment(todayDate,"MM/DD/YYYY"); //default date
      self.open_date = moment(todayDate,"MM/DD/YYYY"); //default date
    }
  },
  methods: {
    mapDealerChanged(newValue){
      if(newValue === '' || newValue === null) {
        this.dealer_id = '';
      }
    },
    stateUpdate(newValue){
      if(newValue === null){
        this.state = '';
      }
    },
    cityUpdate(newValue){
      if(newValue === null){
        this.city_id = '';
      }
    },
    ValidateFormFields(field){
      var self = this;

      if (field === 'name') {
        self.nameerrors = "";
        if((!self.name || self.name == undefined)){
          self.nameerrors = "Name Required";
          self.fieldError = true;
        }
      }else if (field === 'contact_name') {
        self.contact_name_error = "";
        if((!self.contact_name || self.contact_name == undefined)){
          self.contact_name_error = "Contact Name Required";
          self.fieldError = true;
        }
      }else if (field === 'postcode') {
        self.post_code_error = "";
        if((!self.postcode || self.postcode == undefined)){
          self.post_code_error = self.zip_postal + " Required";
          self.fieldError = true;
        }
      }else if(field == 'email'){
        self.emailerrors = "";
        if((!self.email || self.email == undefined)){
          self.emailerrors = "Email Required";
          self.fieldError = true;
        }else{
          if(!self.validEmail(self.email)){
            self.emailerrors = "Please enter valid email address";
            self.fieldError = true;
          }
        }
      }else if(field == 'phone_no'){
        self.phonenoerrors = "";
        if(!self.phone_no || self.phone_no == undefined){
          self.phonenoerrors = "Phone Required";
          self.fieldError = true;
        }else{
          var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if(!self.phone_no.match(phoneRE)){
            self.phonenoerrors = "Please enter valid phone number";
            self.fieldError = true;
          }
        }
      }else if(field == 'address_line_1'){
        self.addressLine1Error = '';
        if(!self.address_line_1 || self.address_line_1 == undefined){
          self.addressLine1Error = "Address Line 1 Required";
          self.fieldError = true;
        }
      }else if(field == 'state'){
        self.stateErrors = "";
        if(!self.state || self.state == undefined){
          self.stateErrors = this.state_province +  " Required";
          self.fieldError = true;
        }
      }else if(field == 'city_id'){
        self.city_error_msg = "";
        if(!self.city_id || self.city_id == undefined){
          self.city_error_msg = "City Required";
          self.fieldError = true;
        }
      }else if(field == "open_date"){
        self.opendateerrormsg = "";
        if(!self.open_date || self.open_date == undefined){
          self.opendateerrormsg = "Open Date Required";
          self.fieldError = true;
        }
      }else if(field == 'dealer_id'){
        self.dealer_error_msg = "";
        if(!self.dealer_id || self.dealer_id == undefined){
          self.dealer_error_msg = "Dealer Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_company_name'){
        self.billing_company_name_error_msg = "";
        if(!self.billing_company_name || self.billing_company_name == undefined){
          self.billing_company_name_error_msg = "Billing Company Name Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_address_line_one'){
        self.billing_address_line_one_error_msg = "";
        if(!self.billing_address_line_one || self.billing_address_line_one == undefined){
          self.billing_address_line_one_error_msg = "Billing Address Line 1 Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_city'){
        self.billing_city_error_msg = "";
        if(!self.billing_city || self.billing_city == undefined){
          self.billing_city_error_msg = "Billing City Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_state'){
        self.billing_state_error_msg = "";
        if(!self.billing_state || self.billing_state == undefined){
          self.billing_state_error_msg = "Billing " + this.state_province +  " Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_zip'){
        self.billing_zip_error_msg = "";
        if(!self.billing_zip || self.billing_zip == undefined){
          self.billing_zip_error_msg = "Billing "+ this.zip_postal +" Required";
          self.fieldError = true;
        }
      }
      else if(field == 'billing_email'){
        self.billing_email_error_msg = "";
        if((self.billing_email !== "" && self.billing_email != null)){
          if(!self.validEmail(self.billing_email)){
            self.billing_email_error_msg = "Please enter valid billing email address";
            self.fieldError = true;
          }
        }
      }
      else if(field == 'billing_phone'){
        self.billing_phone_error_msg = "";
        if(self.billing_phone !== "" && self.billing_phone != null){
          var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if(!self.billing_phone.match(phoneRE)){
            self.billing_phone_error_msg = "Please enter valid billing phone number";
            self.fieldError = true;
          }
        }
      }
      else if(field == 'shipping_company_name' && !this.shipping_same_as_billing){
        self.shipping_company_name_error_msg = "";
        if(!self.shipping_company_name || self.shipping_company_name == undefined){
          self.shipping_company_name_error_msg = "Shipping Company Name Required";
          self.fieldError = true;
        }
      }
      else if(field == 'shipping_address_line_one' && !this.shipping_same_as_billing){
        self.shipping_address_line_one_error_msg = "";
        if(!self.shipping_address_line_one || self.shipping_address_line_one == undefined){
          self.shipping_address_line_one_error_msg = "Shipping Address Line 1 Required";
          self.fieldError = true;
        }
      }
      else if(field == 'shipping_city' && !this.shipping_same_as_billing){
        self.shipping_city_error_msg = "";
        if(!self.shipping_city || self.shipping_city == undefined){
          self.shipping_city_error_msg = "Shipping City Required";
          self.fieldError = true;
        }
      }
      else if(field == 'shipping_state' && !this.shipping_same_as_billing){
        self.shipping_state_error_msg = "";
        if(!self.shipping_state || self.shipping_state == undefined){
          self.shipping_state_error_msg = "Shipping " + this.state_province +  " Required";
          self.fieldError = true;
        }
      }
      else if(field == 'shipping_zip' && !this.shipping_same_as_billing){
        self.shipping_zip_error_msg = "";
        if(!self.shipping_zip || self.shipping_zip == undefined){
          self.shipping_zip_error_msg = "Shipping "+ this.zip_postal + " Required";
          self.fieldError = true;
        }
      }
      else if(field == 'shipping_email' && !this.shipping_same_as_billing){
        self.shipping_email_error_msg = "";
        if((self.shipping_email !== "" && self.shipping_email != null)){
          if(!self.validEmail(self.shipping_email)){
            self.shipping_email_error_msg = "Please enter valid shipping email address";
            self.fieldError = true;
          }
        }
      }
      else if(field == 'shipping_phone' && !this.shipping_same_as_billing){
        self.shipping_phone_error_msg = "";
        if(self.shipping_phone !== "" && self.shipping_phone != null){
          var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
          if(!self.shipping_phone.match(phoneRE)){
            self.shipping_phone_error_msg = "Please enter valid shipping phone number";
            self.fieldError = true;
          }
        }
      }
      return self.fieldError;
    },
    popCityName(cid){
      this.city_id = {value: cid.id, text: cid.name};
    },

    onSearchState(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },

    onSearchCustomer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'primeCustomer', '');
      }
    },

    onCustomerSelect(event) {
      var self = this;

      if (self.customer_id != null && self.customer_id != "") {

        self.loadConsumer();
        self.stageDisable = true;
        self.flag = "";

      }
    },

    onSearchSalesRepresentative(search, loading) {
      var self = this;
      if (search.length > 0) {
        loading(true);
        self.searchField(loading, search, 'user', '');
      }
    },

    onSearchTaxState(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },

    onSearchCity(search, loading) {

      var self = this;
      if (search.length > 2) {

        var stateId = self.state.value;
        if ( stateId == "" ) {
          alert("please select state first");
          return;
        }

        loading(true);
        self.searchField(loading, search, 'city', '');
      }
    },

    BackConsumerList() {
      var self = this;
        self.$router.push("/customer/list");
    },



    CreateConsumer(flag) {
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");

      // Trigger form validation
      self.formFieldsToWatch.forEach(field => {
        self.ValidateFormFields(field);
      });

      self.code = String(self.code).trim();
      self.customFlag = flag;

      var is_ev = 'false';
      if (self.is_dealerpro){
        is_ev = 'true';
      }

      if (!self.fieldError) {
        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3])
        {
          $("#CreateConsumerBtn").val("Updating ...");
          $("#CreateConsumerBtn").prop("disabled", true);
          $("#cancelCustomerBtn").prop("disabled",true);
        } else {
          if (flag == "Save and Continue") {

            $("#createAndContinueCustomerBtn").val("Saving ...");
            $("#CreateConsumerBtn").prop("disabled", true);
            $("#createAndContinueCustomerBtn").prop("disabled", true);
            $("#cancelCustomerBtn").prop("disabled",true);

          }else{

            $("#CreateConsumerBtn").val("Saving ...");
            $("#CreateConsumerBtn").prop("disabled", true);
            $("#createAndContinueCustomerBtn").prop("disabled", true);
            $("#cancelCustomerBtn").prop("disabled",true);
          }

        }

        self.corcentric_inv_date = moment(self.corcentric_inv_date).format('MM/DD/YYYY');
        var currentDate = self.getTodayDate();
        currentDate= moment(currentDate).format('MM/DD/YYYY'); //default date

        var fields = $("#CustomerForm").serializeArray();

        fields.push({ name: "consumerId", value: segments[3] !== null ? segments[3] : 0  });
        fields.push({ name: "name", value: self.name });
        fields.push({ name: "contact_name", value: self.contact_name });
        fields.push({ name: "status", value: self.status.value });
        if(self.hide_for_ev == false){
          fields.push({ name: "location_id", value: self.location_id.value });
        } else {
          //set location null for EV
          fields.push({ name: "location_id", value: null });
        }
        fields.push({ name: "stage", value: self.stage.value });
        fields.push({ name: "is_national_lease", value: self.is_national_lease });
        fields.push({ name: "deposit_check", value: self.deposit_check });
        fields.push({ name: "po_required", value: self.po_required });
        if (self.type == null || !self.type.value) {
          fields.push({ name: "type", value: "" });
        } else {
          fields.push({ name: "type", value: self.type.value });
        }
        if (self.term_id == null || !self.term_id.value) {
          fields.push({ name: "term_id", value: "" });
        } else {
          fields.push({ name: "term_id", value: self.term_id.value });
        }
        if (self.fuel_term_id == null || !self.fuel_term_id.value) {
          fields.push({ name: "fuel_term_id", value: "" });
        } else {
          fields.push({ name: "fuel_term_id", value: self.fuel_term_id.value });
        }
        if (self.credit_manager_id == null || !self.credit_manager_id.value) {
          fields.push({ name: "credit_manager_id", value: "" });
        } else {
          fields.push({ name: "credit_manager_id", value: self.credit_manager_id.value });
        }
        if (self.class_id == null || !self.class_id.value) {
          fields.push({ name: "class_id", value: "" });
        } else {
          fields.push({ name: "class_id", value: self.class_id.value });
        }
        if (self.sales_representative_id == null || !self.sales_representative_id.value) {
          fields.push({ name: "sales_representative_id", value: "" });
        } else {
          fields.push({ name: "sales_representative_id", value: self.sales_representative_id.value });
        }

        // fields.push({name: 'timezone', value: self.selectedTimezone.value});
        fields.push({name: "date_format", value: self.selectDateFormat.value});
        fields.push({name: "time_format", value: self.selectTimeFormat.value});

        if (self.state == null) {
          fields.push({name: "state_id", value: ""});
        } else{
          fields.push({name: "state_id", value: self.state.value});
        }

        if (self.city_id == null) {
          fields.push({name: "city_id", value: ""});
        } else{
          fields.push({name: "city_id", value: self.city_id.value});
        }
        if (segments[3]) {
          fields.push({name: "customer_since", value: self.customer_since});
        }
        if (self.corcentric_default_po == null){
          fields.push({name: "cor_default_po", value: ""});
        }else{
          fields.push({name: "cor_default_po", value: self.corcentric_default_po});
        }
        if (self.is_national_lease === 0){
          fields.push({name: "cor_enabled", value:""});
          fields.push({name: "cor_enabled_date",value:""});
        }else{
          fields.push({name: "cor_enabled", value: self.enable_corcentric});
          if (self.enable_corcentric === 1){
            fields.push({name: "cor_enabled_date",value: currentDate});
          }else{
            fields.push({name: "cor_enabled_date",value:""});
          }
        }
        if  (self.corcentric_inv_date == null){
          fields.push({name:"cor_inv_start_date",value:""});
        }else{
          fields.push({name:"cor_inv_start_date",value:self.corcentric_inv_date});
        }
        if (self.corcentric_code == null){
          fields.push({name:"corcentric_code",value:""});
        }else{
          fields.push({name:"corcentric_code",value:self.corcentric_code});
        }

        fields.push({name: "billing_addresses", value: JSON.stringify(self.setBillingAddressesArray())});
        fields.push({name: "shipping_addresses", value: JSON.stringify(self.setShippingAddressesArray())});
        fields.push({name: "billing_and_shipping_same", value: self.shipping_same_as_billing})

        fields.push({name: "mapped_customer_id",value:self.dealer_id.value});
        var custContactArr = [];
        //customer contact array
        for(var i = 0;i < self.customerContactArr.length;i++) {
          if (self.customerContactArr[i].contact_name != null && self.customerContactArr[i].contact_name.trim() != "") {
            custContactArr.push({
              contact_id:self.customerContactArr[i].contact_id ? self.customerContactArr[i].contact_id : 0,
              contact_type:self.customerContactArr[i].contact_type,
              contact_name:self.customerContactArr[i].contact_name,
              contact_email:self.customerContactArr[i].contact_email,
              contact_phone:(self.customerContactArr[i].contact_phone != "___-___-____")?self.customerContactArr[i].contact_phone:"",
              contact_fax:(self.customerContactArr[i].contact_fax.trim() != "___-___-____")?self.customerContactArr[i].contact_fax.trim():"",
              disable_allow_login:self.customerContactArr[i].disable_allow_login,
              contact_allow_login:self.customerContactArr[i].contact_allow_login,
              contact_password:self.customerContactArr[i].contact_password,
              contact_method:(self.customerContactArr[i].contact_method != null &&
                self.customerContactArr[i].contact_method != "")?self.customerContactArr[i].contact_method.value:""
            });
          }
        }
        fields.push({name: "customer_contact", value: JSON.stringify(custContactArr)});
        //fields.push({name: "customer_login_check",value:self.customer_login_check});
        fields.push({name: "is_ev",value:is_ev});
        $.ajax({
          url: process.env.ROOT_API + "/consumer/create",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (segments[3])
            {
              $("#CreateConsumerBtn").val("Update");
              $("#CreateConsumerBtn").prop("disabled", false);
              $("#cancelCustomerBtn").prop("disabled",false);
            } else {
              if (flag == "Save and Continue") {

                $("#createAndContinueCustomerBtn").val("Save and Continue");
                $("#CreateConsumerBtn").prop("disabled", false);
                $("#createAndContinueCustomerBtn").prop("disabled", false);
                $("#cancelCustomerBtn").prop("disabled",false);

              }else{

                $("#CreateConsumerBtn").val("Save");
                $("#CreateConsumerBtn").prop("disabled", false);
                $("#createAndContinueCustomerBtn").prop("disabled", false);
                $("#cancelCustomerBtn").prop("disabled",false);

              }
            }
            if (data.status == "success") {

              if (flag == "Save and Continue") {

                $("#CustomerForm").trigger("reset");
                self.stageDisable = false;
                self.primeDisable = false;
                self.customer_id = null;
                self.name ="";
                self.code = "";
                self.class_id = null;
                self.size_of_fleet = "";
                self.state = null
                self.city_id = null;
                self.status = {value: "active", text: "Active"};
                self.stage = {value: "potential", text: "Pending Approval"};
                self.customer_since = "";
                self.open_date = currentDate;
                // self.credit_limit = "";
                //self.credit_on_hand = 0;
                //self.ignore_wo_credit_check = 0;
                self.is_national_lease=0;
                self.deposit_check=0;
                self.wo_credit_warning_at = "";
                self.credit_manager_id = null;
                //self.error_at = "";
                //self.maintenance_limit = "";
                self.po_required = 0;
                self.outstanding_ar = 0;
                self.term_id = null;
                self.fuel_term_id = null;
                //self.tax_id = null;
                //self.tax_state_id = null;
                self.sales_representative_id = null;
                //self.use_standard_billing_hours = 0;
                self.email = "";
                self.phone_no = "";
                if (self.$refs.phoneInput && self.$refs.phoneInput.cleave) {
                  self.$refs.phoneInput.cleave.setRawValue(''); // Clears the Cleave formatting
                }
                self.cityArr=  [];
                self.type = '';
                //self.dot = '';
                self.address_line_1 = '';
                self.address_line_2 = '';
                self.postcode = '';
                self.timezone_id = '';
                self.selectDateFormat = {value: "m/d/Y", text: '12/23/2019'};
                self.selectTimeFormat = {value: "h:i:s a", text: '09:58:00 am'};
                self.codeField1 = "";
                self.codeField2 = "";
                self.codeField3 = "";
                self.corcentric_code = "";
                self.customerContactArr = [];
                self.dealer_id = "";
                self.dealerArr = [];
                self.contact_name = "";
                self.status = "";
                self.clearBillingAddress();
                self.clearShippingAddress();
                self.shipping_same_as_billing = false;
                self.scrollToTop();
              } else if ( flag == "Save and Credit") {

                self.$router.push({ name: 'CustomerCreditInformation',params:{id:data.content.id }});
                //customer-credit-information/create

              } else{

                if (segments[3]) {

                  self.$router.push("/customer/list");

                }else if(self.$route.params.redirectFrom == 'WorkOrderCreate' && self.$route.params.redirectFrom != undefined){

                  self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Work Order Customer', customerId: data.content.id, customerName: data.content.name, customerCode: data.content.code}});

                }else if(self.$route.params.redirectFrom == 'CustomerEstimateCreate' && self.$route.params.redirectFrom != undefined){

                  self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Customer Estimate Customer', customerId: data.content.id, customerName: data.content.name, customerCode: data.content.code}});

                }else if(self.$route.params.redirectFrom == 'VendorEstimateCreate' && self.$route.params.redirectFrom != undefined){

                  self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Vendor Estimate Customer', customerId: data.content.id, customerName: data.content.name, customerCode: data.content.code}});

                } else {
                  var stateVal="";
                  var stateText="";
                  var cityVal="";
                  var cityText="";
                  if(self.state != null){
                    stateVal=self.state.value;
                    stateText=self.state.text;
                  }
                  if(self.city_id != null){
                    cityVal=self.city_id.value;
                    cityText=self.city_id.text;
                  }

                  // self.$router.push("/customercontact/add?customerId=" + data.content.id + "&customerName=" + data.content.name + "&customerCode=" + data.content.code);
                  var urlParams = "&customerId=" + data.content.id + "&customerName=" + data.content.name + "&customerCode=" + data.content.code + "&address_1=" + data.content.address_line_1 + "&address_2=" + data.content.address_line_2 + "&phone_no=" + self.phone_no +
                    "&stateId=" + stateVal + "&stateVal=" + stateText + "&cityId=" + cityVal + "&cityVal=" + cityText;

                  // self.$router.push({ name: 'CustomerContactCreate', query: { data : btoa(urlParams) }});
                  self.$router.push("/customer/list");
                }

              }

            } else {
              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                }
                $("#errorMsg").html(err);
                $(".alert-warning").toggleClass("show");
                setTimeout(function () {
                  $(".alert-warning").removeClass("show");
                  $(".alert-warning").addClass("hide");
                }, 10000);
              }
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            if (segments[3])
            {
              $("#CreateConsumerBtn").val("Update");
              $("#CreateConsumerBtn").prop("disabled", false);
              $("#cancelCustomerBtn").prop("disabled",false);
            } else {
              if (flag == "Save and Continue") {

                $("#CustomerForm").trigger("reset");


                $("#createAndContinueCustomerBtn").val("Save and Continue");
                $("#CreateConsumerBtn").prop("disabled", false);
                $("#createAndContinueCustomerBtn").prop("disabled", false);
                $("#cancelCustomerBtn").prop("disabled",false);

              }else{

                $("#CreateConsumerBtn").val("Save");
                $("#CreateConsumerBtn").prop("disabled", false);
                $("#createAndContinueCustomerBtn").prop("disabled", false);
                $("#cancelCustomerBtn").prop("disabled",false);

              }
            }

            self.generateStatusCodeMessage(jqXHR,true,'create-customer-message')
//                    }
          }
        });
      } else {
        //this is used for trigger error in case any vuemodel updated
        self.contactTableKey = self.contactTableKey + 1;
        self.errorValidationFocus();
      }

    },

    loadConsumer() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.isEdit = true;
      self.loading = true;
      var id = 0;
      if(segments[3]){
        id = segments[3];
      }else if(self.flag != ''){
        id = self.codeField2;
      }else{
        id = self.customer_id.value;
      }
      $.ajax({
        url: process.env.ROOT_API + "/consumer/" + id,
        type: "GET",
        headers: this.ajxHeaders,
        data:{
          flag : self.flag,
          action_flag : 'edit', // pass action for notify: view, edit
          is_notify_flag : true // notify if user viewing or editing
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
              self.consumer_id = data.content.id;
              self.name = data.content.name;

              if(data.content.open_date != "" || data.content.open_date != null){
                self.open_date = data.content.open_date;
              }else{
                self.open_date = "";
              }

              self.email = data.content.email;
              self.phone_no = data.content.phone_no;
              self.contact_name = data.content.contact_name;
              self.selectDateFormat = {value: data.content.date_format, text: data.content.date};
              self.selectTimeFormat = {value: data.content.time_format, text: data.content.time};

              self.address_line_1 = data.content.address_line_one;
              self.address_line_2 = data.content.address_line_two;
              self.postcode = data.content.postcode;


              if (data.content.size_of_fleet == 0) {
                self.size_of_fleet = "";
              } else {
                self.size_of_fleet = data.content.size_of_fleet;
              }

              if(data.content.state_id == null){
                self.state = null;
              } else {
                self.state = {value: data.content.state_id, text: data.content.stName};
              }

              if(data.content.city_id == null){
                self.city_id = null;
              } else {
                self.city_id = {value: data.content.city_id, text: data.content.caName};
              }

              self.status = {
                value: data.content.status,
                text: self.formatString(data.content.status)
              };

              if (data.content.customer_contacts != undefined && data.content.customer_contacts != null) {
                self.customerContactArr = data.content.customer_contacts;
              }else{
                self.customerContactArr = [];
              }
              self.disableCustomerSince = true;

              if(data.content.mapped_customer_id != null){
                self.dealer_id = {
                  'text': data.content.mapped_customer_name + "- ( "+ data.content.bill_cus_id +" )",
                  'value': data.content.mapped_customer_id,
                  'parent_id': data.content.mapped_customer_parent_id,
                };
              }
              if(data.content.billing_and_shipping_same === 0){
                self.shipping_same_as_billing = false;
              }else{
                self.shipping_same_as_billing = true;
              }
              if(data.content.billing_address != null){
                self.loadBillingAddress(data.content.billing_address)
              }
              if(data.content.shipping_address != null){
                self.loadShippingAddress(data.content.shipping_address)
              }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;

          self.generateStatusCodeMessage(jqXHR,true,'create-customer-load')
        }
      });
    },

    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    formatString(data) {
      var self = this;
      var value = data.replace(/_/g, " ");
      var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
      });
      return upp;
    },

    titleCase(str) {
      if (str == null){
        return;
      } else{
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },


    isNumber: function(evt) {

      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    /* removeSpace(str) {
        var target = this;
        return target.split(search).join(replacement);
    } */
    onCustomerTypeIn:function(){
      var self = this;
      var path = window.location.pathname;
      var segments = path.split("/");
      //  if (self.customer_id == null && (!segments[3])){
      if ((!segments[3])){
        if(self.codeField2 != ""){
          // self.primeDisable = true;
          self.flag = "check_parent";
          self.loadConsumer();
        }
      }

    },
    onSearchDealer(search, loading) {
      var self = this;
      if (search.length > 2) {
        loading(true);
        self.searchField(loading, search, 'dealer', '');
      }
    },
    checkSelected(evt) {
      if (evt.target.checked == true) {
        this.shipping_same_as_billing = true;
        this.setShippingSameAsBilling();
      } else {
        this.shipping_same_as_billing = false;
        this.clearShippingAddress();
      }
      this.clearShippingRequiredErrorMessages();
    },
    setShippingSameAsBilling() {
      this.shipping_company_name = this.billing_company_name;
      this.shipping_address_line_one = this.billing_address_line_one;
      this.shipping_address_line_two = this.billing_address_line_two;
      this.shipping_city = this.billing_city;
      this.shipping_state = this.billing_state;
      this.shipping_zip = this.billing_zip;
      this.shipping_contact_name = this.billing_contact_name;
      this.shipping_email = this.billing_email;
      this.shipping_phone = this.billing_phone;
      if (this.$refs.shippingPhoneInput && this.$refs.shippingPhoneInput.cleave) {
        this.$refs.shippingPhoneInput.cleave.setRawValue(''); // Clears the Cleave formatting
      }
    },
    setBillingAddressesArray(){
      return {
        'billing_company_name': this.billing_company_name,
        'billing_address_line_one': this.billing_address_line_one,
        'billing_address_line_two': this.billing_address_line_two,
        'billing_city': this.billing_city,
        'billing_state': this.billing_state,
        'billing_zip': this.billing_zip,
        'billing_contact_name': this.billing_contact_name,
        'billing_email': this.billing_email,
        'billing_phone': this.billing_phone,
      }
    },
    setShippingAddressesArray(){
      return {
        'shipping_company_name': this.shipping_company_name,
        'shipping_address_line_one': this.shipping_address_line_one,
        'shipping_address_line_two': this.shipping_address_line_two,
        'shipping_city': this.shipping_city,
        'shipping_state': this.shipping_state,
        'shipping_zip': this.shipping_zip,
        'shipping_contact_name': this.shipping_contact_name,
        'shipping_email': this.shipping_email,
        'shipping_phone': this.shipping_phone,
      }
    },
    clearBillingAddress(){
      this.billing_company_name = "";
      this.billing_address_line_one = "";
      this.billing_address_line_two = "";
      this.billing_city = "";
      this.billing_state = "";
      this.billing_zip = "";
      this.billing_contact_name = "";
      this.billing_email = "";
      this.billing_phone = "";
      if (this.$refs.billingPhoneInput && this.$refs.billingPhoneInput.cleave) {
        this.$refs.billingPhoneInput.cleave.setRawValue(''); // Clears the Cleave formatting
      }
    },
    clearShippingAddress(){
      this.shipping_company_name = "";
      this.shipping_address_line_one = "";
      this.shipping_address_line_two = "";
      this.shipping_city = "";
      this.shipping_state = "";
      this.shipping_zip = "";
      this.shipping_contact_name = "";
      this.shipping_email = "";
      this.shipping_phone = "";
      if (this.$refs.shippingPhoneInput && this.$refs.shippingPhoneInput.cleave) {
        this.$refs.shippingPhoneInput.cleave.setRawValue(''); // Clears the Cleave formatting
      }
    },
    clearShippingRequiredErrorMessages(){
      this.shipping_company_name_error_msg = "";
      this.shipping_address_line_one_error_msg = "";
      this.shipping_city_error_msg = "";
      this.shipping_state_error_msg = "";
      this.shipping_zip_error_msg = "";
      this.shipping_phone_error_msg = "";
      this.shipping_email_error_msg = "";
    },
    loadBillingAddress(billingAddressData){
      this.billing_company_name = billingAddressData.company_name;
      this.billing_address_line_one = billingAddressData.address_line_one;
      this.billing_address_line_two = billingAddressData.address_line_two;
      this.billing_city = billingAddressData.city;
      if(billingAddressData.state != null){
        this.billing_state = {'value':billingAddressData.state.id, 'text':billingAddressData.state.code};
      }
      this.billing_zip = billingAddressData.zip_code;
      this.billing_contact_name = billingAddressData.contact_name;
      this.billing_email = billingAddressData.contact_email;
      this.billing_phone = billingAddressData.contact_phone;
    },
    loadShippingAddress(shippingAddressData){
      this.shipping_company_name = shippingAddressData.company_name;
      this.shipping_address_line_one = shippingAddressData.address_line_one;
      this.shipping_address_line_two = shippingAddressData.address_line_two;
      this.shipping_city = shippingAddressData.city;
      if(shippingAddressData.state != null){
        this.shipping_state = {'value':shippingAddressData.state.id, 'text':shippingAddressData.state.code};
      }
      this.shipping_zip = shippingAddressData.zip_code;
      this.shipping_contact_name = shippingAddressData.contact_name;
      this.shipping_email = shippingAddressData.contact_email;
      this.shipping_phone = shippingAddressData.contact_phone;
    },
  }
};


</script>
<style scoped>
.table-mt-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConsumerCreate.vue